import React from 'react';

export default function ForgetPassword() {
  return <div>ForgetPassword</div>;
}
